import React from 'react'
import styled from 'styled-components'

import agentsLaunchBackground from 'assets/images/agents-launch-background.jpg'
import { useAnnouncementBanner } from 'components/ui/AnnouncementBanner'

const LEARN_MORE_URL =
  'https://stonly.com/guide/en/agents-4Ydu41N6IT/Steps/5185261'

interface Props {
  onCreateCustomAgent: () => void
}

export const AgentsLaunchBanner: React.FC<Props> = ({
  onCreateCustomAgent,
}) => {
  const { dismiss, trackCta } = useAnnouncementBanner()

  const handleCreate = (): void => {
    trackCta('create_custom_agent')
    onCreateCustomAgent()
  }

  const handleLearnMore = (): void => {
    trackCta('learn_more')
  }

  return (
    <Container>
      <Card>
        <Header>
          <Title>Yogi Agents are always on the lookout</Title>
          <Body>
            Issue agents catch emerging issues early. Benchmarking agents
            highlight where you stand against your cohort. Set up a custom agent
            to monitor what matters most.
          </Body>
        </Header>

        <ButtonRow>
          <PrimaryCta onClick={handleCreate}>Create custom agent</PrimaryCta>
          <LearnMoreLink
            href={LEARN_MORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleLearnMore}
          >
            <SecondaryCta>Learn more</SecondaryCta>
          </LearnMoreLink>
        </ButtonRow>
      </Card>

      <CloseButton aria-label="Close banner" onClick={dismiss}>
        <svg width="12" height="12" fill="none" viewBox="0 0 8.10667 8.10667">
          <path
            d="M7.38667 0.72L0.72 7.38667M0.72 0.72L7.38667 7.38667"
            stroke="#717680"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.44"
          />
        </svg>
      </CloseButton>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 28px 31px;
  overflow: hidden;
  font-family: 'Poppins', sans-serif;
  background:
    url(${agentsLaunchBackground}) center right / cover no-repeat,
    linear-gradient(135deg, #e8eef7 0%, #c4d3e8 100%);
  border-radius: 24px;
  width: 100%;
  margin-bottom: 0;
`

const Card = styled.div`
  width: 557.5px;
  min-height: 207px;
  flex-shrink: 0;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 25px 26px;
  display: flex;
  flex-direction: column;
  gap: 28px;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

const Title = styled.h2`
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: #28364f;
`

const Body = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #28364f;
`

const ButtonRow = styled.div`
  display: flex;
  gap: 9px;
  align-items: flex-start;
  flex-wrap: wrap;
`

const PrimaryCta = styled.button`
  background-color: #4f72a4;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  white-space: nowrap;
`

const SecondaryCta = styled.button`
  background-color: #ffffff;
  color: #414651;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #d5d7da;
  cursor: pointer;
  white-space: nowrap;
`

const LearnMoreLink = styled.a`
  text-decoration: none;
`

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: #ffffff;
  padding: 6px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`
